import { Button, List, ListItem, Popover } from '@material-ui/core';
import { useEffect } from 'react';
import { useState } from 'react';
import en from '../../lang/en-us';
import { validUploadFileFormats, validUploadFileSize } from '../../utils/constants';
const { dashboard } = en;

const AndriodUploadOptions = ['Camera', 'Browse Files'];

const _getFileType = (fileType: string) => {
    if (fileType === 'application/pdf') {
        return 'PDF';
    }
    if (fileType === 'image/png') {
        return 'PNG';
    }
    if (fileType === 'image/jpeg') {
        return 'JPEG';
    }
    if (fileType === 'image/jpg') {
        return 'JPG';
    }
};

type extraOptionsOnSelect = {
    name: String;
}

export function UploadFile({
    documentFormat = 'Document Format : .pdf / .jpg / .jpeg / .png',
    setImageName = (name: any) => { },
    onImageSelected = (value: any, format?: any, options?:extraOptionsOnSelect) => { },
    id = 'upload-document',
    initSelected = false,
    imageName = '',
}) {
    const [selectedFile, setSelectedFile] = useState({ name: imageName });
    const [isSelected, setIsSelected] = useState(initSelected);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    useEffect(() => {
        setIsSelected(initSelected);
    }, [initSelected]);

    useEffect(() => {
        setSelectedFile({ name: imageName || '' });
    }, [imageName]);

    const _window: any = window;
    const _navigator: any = navigator;

    function getBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }

    const changeHandler = async (event: any) => {
        setSelectedFile(event.target.files[0]);
        const name = event.target.files[0].name
        setImageName(name);
        try {
            const base64: any = await getBase64(event.target.files[0]);
            let fileType = event.target.files[0].type;
            const fileSize = event.target.files[0].size;
            if (!validUploadFileFormats.includes(fileType)) {
                throw Error('Please upload correct format');
            }
            if (fileSize > validUploadFileSize) {
                throw Error('File size should be less than 2 MB');
            }
            onImageSelected(base64.split(',')[1], _getFileType(fileType),{name});
            event.target.value = null;
            setIsSelected(true);
        } catch (e: any) {
            alert(e.message);
            event.target.value = null;
        }
    };

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getPic = () => {
        if (_navigator.camera) {
            _navigator.camera.getPicture(onCameraSuccess, onFail, {
                quality: 25,
                destinationType: _window.Camera.DestinationType.DATA_URL,
            });
        }
    };

    const browseFiles = () => {
        if (_navigator.camera) {
            _navigator.camera.getPicture(onCameraSuccess, onFail, {
                quality: 50,
                destinationType: _window.Camera.DestinationType.DATA_URL,
                sourceType: _window.Camera.PictureSourceType.PHOTOLIBRARY,
                encodingType: _window.Camera.EncodingType.JPEG,
                mediaType: _window.Camera.MediaType.PICTURE,
                allowEdit: false,
                correctOrientation: true,
            });
        }
    };

    const onCameraSuccess = (imageData: string) => {
        const name = `photo_${Date.now()}.jpg`;
        // Some Android/plugin versions return a full data URI (data:image/jpeg;base64,...)
        // instead of bare base64. Strip the prefix so the backend decoder gets clean base64.
        const content = imageData.includes(',') ? imageData.split(',')[1] : imageData;
        setSelectedFile({ name });
        setImageName(name);
        onImageSelected(content, 'JPEG', { name });
        setIsSelected(true);
    };

    function onFail(message: string) {
        // alert('Failed because: ' + message);
    }

    const fileOptions: any =
        _window?.device?.platform !== 'Android'
            ? {
                type: 'file',
                onChange: changeHandler,
            }
            : {};

    const onSelect = (option: string) => {
        handleClose();
        if (option === AndriodUploadOptions[0]) {
            getPic();
            setAnchorEl(null);
        } else {
            browseFiles();
        }
    };
    return (
        <div className="upload-file-outer" style={{paddingLeft:'0px'}}>
            <div className="upload-file">
                <input accept=".jpeg, .pdf, .png, .jpg" id={id} {...fileOptions} />
                {isSelected ? (
                    <>
                        <h6>
                            {selectedFile.name}{' '}
                            <img
                                src="/images/close-black.svg"
                                alt="icon"
                                onClick={() => {
                                    onImageSelected('', '');
                                    setIsSelected(false);
                                    setSelectedFile({ name: '' });
                                }}
                            />
                        </h6>
                    </>
                ) : (
                    <label htmlFor={id}>
                        <Button
                            onClick={(e: any) =>
                                _window?.device?.platform === 'Android' ? handleOpen(e) : null
                            }
                            variant="contained"
                            color="primary"
                            component="span"
                        >
                            {dashboard.changeEmail.UploadDocument.uploadBtnText}
                        </Button>
                    </label>
                )}
            </div>
            <div className="upload-file-info">
                <p>{dashboard.ChangeTaxStatus.uploadDocumentsInfo}</p>
            </div>
            <Popover
                id={id}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <List component="nav" aria-label="secondary mailbox folders">
                    {AndriodUploadOptions.map((ele) => (
                        <ListItem key={ele}>
                            <a
                                onClick={() => {
                                    onSelect(ele);
                                }}
                            >
                                {ele}
                            </a>
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </div>
    );
}
